import { Component, Input } from '@angular/core';
import { BxUnverifiedAlertService } from '../../../../../core/services/bx-unverified-alert.service';
import { SharedDataService } from '../../../../../data/services/shared-data.service';
import { ContactsService } from '../../../contacts.service';

@Component({
    selector: 'app-contact-emails',
    templateUrl: './contact-emails.component.html',
    standalone: false,
})
export class ContactEmailsComponent {
    // @ts-ignore TS7008
    @Input() contact;

    constructor(
        private contactsService: ContactsService,
        private sharedData: SharedDataService,
        private readonly bxUnverifiedAlertService: BxUnverifiedAlertService
    ) {}

    newEmail() {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }
        this.contactsService.emailContact(this.contact);
    }
}
